export const SORT_CONFIG_FUNNEL = {
  title: {
    type: 'string',
    field: 'title'
  },
  total: {
    type: 'object',
    field: 'total.value'
  },
  resume: {
    type: 'object',
    field: 'resume.value'
  },
  documents: {
    type: 'object',
    field: 'documents.value'
  },
  medical_check: {
    type: 'object',
    field: 'medical_check.value'
  },
  tickets: {
    type: 'object',
    field: 'tickets.value'
  },
  accepted: {
    type: 'object',
    field: 'accepted.share'
  },
  conversion: {
    type: 'object',
    field: 'accepted.share'
  }
}

export const SORT_CONFIG_BASE = {
  title: {
    type: 'string',
    field: 'title'
  },
  time: {
    type: 'object',
    field: 'time'
  },
  conversion_value: {
    type: 'object',
    field: 'conversion_value'
  },
  closed_value: {
    type: 'object',
    field: 'closed_value'
  }
}

